import {
  SET_ENTERPRISE_CERTIFICATION_LIST,
  SET_ENTERPRISE_CERTIFICATION_LIST_PAGE,
  SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE,
  SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE_TOTAL,
  SET_ENTERPRISE_CERTIFICATION_QUERY,
  SET_ENTERPRISE_CERTIFICATION_STATUS,
  SET_ENTERPRISE_CERTIFICATION_REMARKS,
  SET_ENTERPRISE_CERTIFICATION_IMAGE,
  SET_ENTERPRISE_CERTIFICATION_SEARCHING,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  userName: '',
  startTime: '',
  endTime: '',
  status: '',       // 验证状态(0未验证1验证中2已通过3已驳回)
})
const state = {
  searching: false,
  initQuery: initQuery(),
  enterpriseCertifications: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
  status: 0,
  remarks: '',
  imgSrcs: [],
}
const mutations = {
  [SET_ENTERPRISE_CERTIFICATION_LIST] (state, payload) {
    state.enterpriseCertifications.list = payload
  },
  [SET_ENTERPRISE_CERTIFICATION_LIST_PAGE] (state, payload) {
    state.enterpriseCertifications.query.pageNum = payload
  },
  [SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE] (state, payload) {
    state.enterpriseCertifications.query.pageSize = payload
  },
  [SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE_TOTAL] (state, payload) {
    state.enterpriseCertifications.listPageTotal = payload
  },
  [SET_ENTERPRISE_CERTIFICATION_QUERY] (state, payload) {
    state.enterpriseCertifications.query = {
      ...state.enterpriseCertifications.query,
      ...payload,
    }
  },
  [SET_ENTERPRISE_CERTIFICATION_STATUS] (state, payload) {
    state.status = payload
  },
  [SET_ENTERPRISE_CERTIFICATION_REMARKS] (state, payload) {
    state.remarks = payload
  },
  [SET_ENTERPRISE_CERTIFICATION_IMAGE] (state, payload) {
    state.imgSrcs = payload
  },
  [SET_ENTERPRISE_CERTIFICATION_SEARCHING] (state, payload) {
    state.searching = payload
  },
}
const actions = {
  async setEnterpriseCertificationList ({commit, state}, payload) {
    try {
      let query = {}
      _.forIn(state.enterpriseCertifications.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageSize: state.enterpriseCertifications.query.pageSize,
        pageNum: state.enterpriseCertifications.query.pageNum,
      }
      const {data: {items, total}} = await api.userApi.queryCertificationList(params)
      commit(SET_ENTERPRISE_CERTIFICATION_SEARCHING, false)
      commit(SET_ENTERPRISE_CERTIFICATION_LIST, items)
      commit(SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE_TOTAL, total)
    } catch (error) {
      commit(SET_ENTERPRISE_CERTIFICATION_LIST, [])
      commit(SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE_TOTAL, 0)
    }
  },
  async changeListPage ({commit, state, dispatch}, payload) {
    commit(SET_ENTERPRISE_CERTIFICATION_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('setEnterpriseCertificationList')
  },
  initEnterpriseCertificationList ({commit, dispatch}, payload) {
    let query = initQuery()
    commit(SET_ENTERPRISE_CERTIFICATION_QUERY, query)
    dispatch('changeListPage', {currentPage: 1})
  },
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_ENTERPRISE_CERTIFICATION_SEARCHING, true)
    commit(SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeListPage', {currentPage: 1})
  },
  changeQuery ({commit, dispatch}, payload) {
    commit(SET_ENTERPRISE_CERTIFICATION_QUERY, payload)
  },
  async changeStatus ({commit}, payload) {
    const {code} = await api.userApi.updateCertification(payload)
    if (code === 200) {
      commit(SET_ENTERPRISE_CERTIFICATION_STATUS, payload.status)
      commit(SET_ENTERPRISE_CERTIFICATION_REMARKS, payload.remarks)
    }
    return code
  },
  async checkDetails ({commit}, payload) {
    const {data: {certificate}} = await api.userApi.queryCertification(payload)
    commit(SET_ENTERPRISE_CERTIFICATION_IMAGE, [certificate])
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
